/**
 * Extracts caller information from the JavaScript stack trace
 */
export function getCallerInfo(skipFrames = 2): string {
  const error = new Error();
  const stack = error.stack;

  if (!stack) {
    return 'unknown';
  }

  const lines = stack.split('\n');

  // Files that should be considered part of the logging system and skipped
  const loggerFiles = [
    'system-logger.ts',
    'system-logger.js',
    'callerInfo.ts',
    'callerInfo.js',
  ];

  // Start from skipFrames + 1 to skip Error constructor and getCallerInfo
  for (let i = skipFrames + 1; i < lines.length; i++) {
    const line = lines[i];

    if (!line) continue;

    // Parse different stack trace formats
    let match = line.match(/at\s+(?:(.+?)\s+\()?(.+?):(\d+):(\d+)/);

    if (!match) {
      // Try Firefox format
      match = line.match(/(.+?)@(.+?):(\d+):(\d+)/);
    }

    if (!match) continue;

    const [, functionName, filePath, lineNumber] = match;
    const fileName = filePath?.split('/').pop()?.split('\\').pop() || 'unknown';

    // Skip if this frame is from a logger file
    const isLoggerFile = loggerFiles.some((loggerFile) =>
      fileName.includes(loggerFile.replace(/\.(ts|js)$/, '')),
    );

    if (!isLoggerFile) {
      // Found the first frame outside the logger system
      if (functionName?.trim() && functionName !== 'Object.<anonymous>') {
        return `${fileName}:${lineNumber} (${functionName.trim()})`;
      } else {
        return `${fileName}:${lineNumber}`;
      }
    }
  }

  // Fallback if we couldn't find a non-logger frame
  return 'unknown';
}
